import { createSelector } from 'reselect'

export const getUserInfo = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.info
    ? state.user.profile.info
    : null,
  info => info
)
